module.exports = __webpack_public_path__ + "static/media/1.bd2d456a.png";